import { useState, useRef } from 'react';
import { Calendar } from 'lucide-react';
import CalendarFilter from './CalendarFilter';

const TimeRangeSelector = ({ selected, onSelect }) => {
  const [showCalendar, setShowCalendar] = useState(false);
  const calendarButtonRef = useRef(null);
  const ranges = ['1D', '5D', '1M', '3M', 'YTD', '1Y', '5Y', 'All'];

  const handleCalendarApply = ({ startDate, endDate }) => {
    console.log('Applied date range:', startDate, 'to', endDate);
    onSelect({ startDate, endDate });
  };
  
  return (
    <>
      <div className="flex items-center gap-1 sm:gap-2 ml-0 sm:ml-6 px-3 sm:px-6 py-3 sm:py-4 overflow-x-auto">
        <div className="flex items-center gap-1 sm:gap-2 min-w-max">
          {ranges.map((range) => (
            <button
              key={range}
              onClick={() => onSelect(range)}
              className={`px-2 sm:px-3 py-1 rounded text-xs sm:text-sm font-medium transition-colors whitespace-nowrap ${
                selected === range
                  ? 'bg-gray-700 text-white'
                  : 'text-gray-300 hover:text-white hover:bg-gray-800'
              }`}
            >
              {range}
            </button>
          ))}
          <div className="border-l border-gray-600 h-5 sm:h-6 mx-0.5 sm:mx-1"></div>
          
          <button 
            ref={calendarButtonRef}
            onClick={() => setShowCalendar(!showCalendar)}
            className="p-1 hover:bg-gray-700 rounded transition-colors"
          >
            <Calendar className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-gray-400" />
          </button>
        </div>
      </div>

      {showCalendar && (
        <CalendarFilter 
          isOpen={showCalendar}
          onClose={() => setShowCalendar(false)}
          onApply={handleCalendarApply}
          triggerRef={calendarButtonRef}
        />
      )}
    </>
  );
};

export default TimeRangeSelector;